import {
  MousePointer2, Slash, MoveHorizontal, MoveVertical, MoveDiagonal, ArrowUpRight, Circle, Square, Crosshair,
  Type, Ruler, TriangleAlert, Undo2, Trash2, Eraser,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { COLORS } from "../../lib/constants";

export const TOOL_META = {
  select: { label: "Selecionar", icon: MousePointer2 },
  line: { label: "Linha", icon: Slash },
  hline: { label: "Linha horizontal", icon: MoveHorizontal },
  vline: { label: "Linha vertical", icon: MoveVertical },
  dline: { label: "Linha diagonal", icon: MoveDiagonal },
  arrow: { label: "Seta", icon: ArrowUpRight },
  circle: { label: "Círculo", icon: Circle },
  rect: { label: "Retângulo", icon: Square },
  point: { label: "Ponto de medição", icon: Crosshair },
  text: { label: "Texto", icon: Type },
  cota: { label: "Cota", icon: Ruler },
  anomaly: { label: "Marcador de anomalia", icon: TriangleAlert },
  axisX: { label: "Eixo X", letter: "X" },
  axisY: { label: "Eixo Y", letter: "Y" },
  axisZ: { label: "Eixo Z", letter: "Z" },
};

export const PALETTE = [
  { key: "dev", color: COLORS.dev, label: "Desalinhamento (vermelho)", width: 4 },
  { key: "ref", color: COLORS.ref, label: "Referência (azul)", width: 2 },
  { key: "measure", color: COLORS.measure, label: "Medição (verde)", width: 2 },
  { key: "yellow", color: COLORS.yellow, label: "Destaque (amarelo)", width: 2 },
  { key: "white", color: COLORS.white, label: "Anotação (branco)", width: 2 },
];

export function DrawToolbar({ tools, tool, setTool, color, setColor, width, setWidth, label, setLabel, onUndo, onDelete, canDelete, onClear, prefix = "draw" }) {
  return (
    <div className="flex flex-col gap-3" data-testid={`${prefix}-toolbar`}>
      <div className="flex flex-wrap gap-1">
        {tools.map((key) => {
          const m = TOOL_META[key];
          const Icon = m.icon;
          return (
            <button key={key} type="button" title={m.label} data-testid={`${prefix}-tool-${key}`} onClick={() => setTool(key)}
              className={cn("h-9 min-w-9 px-2 flex items-center justify-center gap-1.5 rounded-sm border text-xs font-mono transition-colors",
                tool === key ? "bg-[#FFD500] text-[#050B10] border-[#FFD500]" : "border-[#1E2F45] text-slate-300 hover:border-[#FFD500]/60 hover:text-white bg-[#0B1520]")}>
              {Icon ? <Icon size={15} strokeWidth={2.2} /> : <span className="font-bold text-sm">{m.letter}</span>}
              <span className="hidden xl:inline">{m.label}</span>
            </button>
          );
        })}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-1.5">
          {PALETTE.map((p) => (
            <button key={p.key} type="button" title={p.label} data-testid={`${prefix}-color-${p.key}`}
              onClick={() => { setColor(p.color); setWidth(p.width); }}
              className={cn("h-7 w-7 rounded-sm border-2 transition-transform hover:scale-110", color === p.color ? "border-white scale-110" : "border-transparent")}
              style={{ background: p.color }} />
          ))}
        </div>
        <select data-testid={`${prefix}-width-select`} value={width} onChange={(e) => setWidth(Number(e.target.value))}
          className="h-8 bg-[#0B1520] border border-[#1E2F45] rounded-sm px-2 text-xs font-mono text-slate-200">
          {[1, 2, 3, 4, 5, 6, 8].map((w) => <option key={w} value={w}>{w}px</option>)}
        </select>
        <input data-testid={`${prefix}-label-input`} value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Rótulo (texto / cota / ponto)"
          className="h-8 w-52 bg-[#0B1520] border border-[#1E2F45] rounded-sm px-2 text-xs font-mono text-slate-200 focus:outline-none focus:border-[#FFD500]" />
        <div className="flex items-center gap-1 ml-auto">
          <button type="button" data-testid={`${prefix}-undo`} onClick={onUndo} title="Desfazer" className="h-8 w-8 flex items-center justify-center rounded-sm border border-[#1E2F45] text-slate-300 hover:text-white hover:border-[#FFD500]/60"><Undo2 size={15} /></button>
          <button type="button" data-testid={`${prefix}-delete`} onClick={onDelete} disabled={!canDelete} title="Excluir selecionado" className="h-8 w-8 flex items-center justify-center rounded-sm border border-[#1E2F45] text-slate-300 hover:text-white disabled:opacity-30"><Trash2 size={15} /></button>
          <button type="button" data-testid={`${prefix}-clear`} onClick={onClear} title="Limpar anotações" className="h-8 w-8 flex items-center justify-center rounded-sm border border-[#1E2F45] text-slate-300 hover:text-white hover:border-[#FFD500]/60"><Eraser size={15} /></button>
        </div>
      </div>
    </div>
  );
}
